var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-collapse',_vm._l((_vm.platforms),function(p){return _c('el-collapse-item',{key:p.id,attrs:{"title":p.name,"name":p.id}},[_c('BlacklistedPhonesEditor',{attrs:{"platform_id":p.id}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }